/**
 * Rubrique Messages (décision du propriétaire du 25/10/2026) : annonces de
 * l'entreprise et conversations de l'équipe. Ouverte par `messaging.use`, que
 * l'entreprise peut couper pour tous ; publier une annonce demande en plus
 * `announcement.publish`. L'API revérifie chaque geste.
 */
import { lazy } from 'react';
import type { AppRoute, RouteGate } from '../../app/route-types.js';

const MessagesPage = lazy(() => import('./MessagesPage.js').then((m) => ({ default: m.MessagesPage })));
const NewConversationPage = lazy(() => import('./NewConversationPage.js').then((m) => ({ default: m.NewConversationPage })));
const ConversationPage = lazy(() => import('./ConversationPage.js').then((m) => ({ default: m.ConversationPage })));
const AnnouncementPage = lazy(() => import('./AnnouncementPage.js').then((m) => ({ default: m.AnnouncementPage })));
const NewAnnouncementPage = lazy(() => import('./NewAnnouncementPage.js').then((m) => ({ default: m.NewAnnouncementPage })));

const use: RouteGate = { anyOf: ['messaging.use'] };
const publish: RouteGate = { anyOf: ['announcement.publish'] };

export const messagesRoutes: AppRoute[] = [
  { path: '/messages', element: <MessagesPage />, gate: use },
  { path: '/messages/nouveau', element: <NewConversationPage />, gate: use },
  { path: '/messages/annonces/nouvelle', element: <NewAnnouncementPage />, gate: publish },
  { path: '/messages/annonces/:id', element: <AnnouncementPage />, gate: use },
  { path: '/messages/:id', element: <ConversationPage />, gate: use },
];
